import { Reducer } from "redux";
import { TAction } from "loop-front";
import { AppState } from './@types';
import { OApp } from ".";

const AppReducerInitialState: AppState = {
    isAppLinearLoaderVisible: false,
    confirmationDialogConfig: {
        message: '',
        open: false,
        title: ''
    }
}

export const App: Reducer<AppState, TAction> = (state = AppReducerInitialState, action) => {
    const { OPEN_TOAST, CLOSE_TOAST, TOGGLE_APP_LINEAR_LOADER, OPEN_CONFIRMATION_DIALOG, CLOSE_CONFIRMATION_DIALOG } = OApp.Actions;
    switch (action.type) {
        case OPEN_TOAST: return { ...state, toast: { ...action.data } }
        case CLOSE_TOAST: return { ...state, toast: { open: false } }
        case TOGGLE_APP_LINEAR_LOADER: return { ...state, isAppLinearLoaderVisible: action.data }
        case OPEN_CONFIRMATION_DIALOG:
        case CLOSE_CONFIRMATION_DIALOG:
            return { ...state, confirmationDialogConfig: action.data }
        default: return state;
    }
}
